import { Linkedin, Instagram, Twitter, MapPin } from "lucide-react";
import { APP_LINKS, LOGO_URL, NAV_LINKS, scrollToId } from "../../lib/site";

const SOCIALS = [
  { icon: Linkedin, label: "LinkedIn" },
  { icon: Instagram, label: "Instagram" },
  { icon: Twitter, label: "Twitter" },
];

export const Footer = () => (
  <footer
    id="about"
    className="relative bg-navy-900 text-white pt-20 pb-8 overflow-hidden grain"
    data-testid="site-footer"
  >
    <div className="relative z-10 max-w-[1400px] mx-auto px-5 sm:px-8">
      <div className="grid gap-12 lg:grid-cols-[1.4fr_1fr_1fr] border-b border-white/10 pb-14">
        {/* brand */}
        <div>
          <img src={LOGO_URL} alt="SunShell One" className="h-10 w-auto brightness-0 invert" />
          <p className="mt-5 text-white/55 max-w-[34ch] leading-relaxed">
            A Sunshell Power initiative. India's first Home Energy OS — helping
            homes, businesses and farms own their power.
          </p>
          <div className="mt-6 flex items-center gap-3">
            {SOCIALS.map((s) => (
              <a
                key={s.label}
                href="#"
                aria-label={s.label}
                data-testid={`social-${s.label.toLowerCase()}`}
                className="grid h-11 w-11 place-items-center rounded-full border border-white/15 text-white/70 transition-colors duration-300 hover:bg-amber hover:border-amber hover:text-white"
              >
                <s.icon size={18} />
              </a>
            ))}
          </div>
        </div>

        {/* links */}
        <div>
          <h4 className="eyebrow text-white/40 mb-5">Explore</h4>
          <ul className="space-y-3">
            {NAV_LINKS.map((l) => (
              <li key={l.label}>
                <button
                  onClick={() => scrollToId(l.target)}
                  className="text-white/70 transition-colors duration-300 hover:text-amber-400"
                  data-testid={`footer-link-${l.target}`}
                >
                  {l.label}
                </button>
              </li>
            ))}
            <li>
              <a
                href={APP_LINKS.customer.url}
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/70 transition-colors duration-300 hover:text-amber-400"
              >
                Customer App
              </a>
            </li>
            <li>
              <a
                href={APP_LINKS.partner.url}
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/70 transition-colors duration-300 hover:text-amber-400"
              >
                Partner App
              </a>
            </li>
          </ul>
        </div>

        {/* contact */}
        <div>
          <h4 className="eyebrow text-white/40 mb-5">Reach us</h4>
          <p className="flex items-start gap-3 text-white/70 leading-relaxed">
            <MapPin size={18} className="mt-1 shrink-0 text-amber" />
            6th Floor, 602, Building 2A,
            <br />
            ECOSPACE BUSINESS PARK,
            <br />
            Action Area II, New Town,
            <br />
            Chakpachuria, West Bengal 700160
          </p>
          <a href="mailto:info@sunshellpower.com" className="mt-4 inline-block text-white/70 hover:text-amber-400 transition-colors">
            info@sunshellpower.com
          </a>
          <p className="mt-1 text-white/70">+91 76050 07177</p>
        </div>
      </div>

      <p className="text-center display-serif text-xl sm:text-2xl italic text-amber-400 py-10">
        SunShell One. Own Your Power.
      </p>

      <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-white/40">
        <p>© {new Date().getFullYear()} Sunshell Power. All rights reserved.</p>
        <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2">
          <a href="/privacy-policy" className="hover:text-white/70 transition-colors">Privacy</a>
          <a href="/terms-and-conditions" className="hover:text-white/70 transition-colors">Terms</a>
          <a href="/delete-account" className="hover:text-white/70 transition-colors">Delete Account</a>
        </div>
      </div>
    </div>
  </footer>
);
